import {
    GET_ACCOUNT_DATA, GET_ACCOUNT_DATA_RESET,
    GET_DASHBOARD, GET_DASHBOARD_RESET,
    GET_MERCHANT_DETAILS, GET_MERCHANT_DETAILS_RESET,
    GET_MERCHANT_LOCATIONS, GET_MERCHANT_LOCATIONS_RESET,
    GET_MERCHANT_REPORT, GET_MERCHANT_REPORT_RESET,
    GET_ACCOUNT_USERS, GET_ACCOUNT_USERS_RESET,
    GET_USER_ACCOUNT, GET_USER_ACCOUNT_RESET,
    SET_ACTIVE_CONCEPT_ID,
    SET_SELECTED_INDEX, GET_TOTAL_LOCATIONS_COUNT,
    ADD_USER_ACCOUNT, ADD_USER_ACCOUNT_RESET,
    UPDATE_ACCOUNT_DATA, UPDATE_ACCOUNT_DATA_RESET
} from '../actions';
import {getActiveConceptId, getSelectedIndex, setActiveConceptId, setSelectedIndex} from "../utilities";



import {
    SET_MODAL,
    SET_MODAL_RESET,
} from "../actions/app";


const initialState = {
    modal: null,
    getDashboardSuccess: null,
    activeConcept: {},
    merchantGroup: {},
    concepts: {},
    getMerchantReportSuccess: null,
    getAccountDataSuccess: null,
    accountData: {},
    getAccountUsersSuccess: null,
    accountUsers: [],
    userAccount: {},
    getUserAccountSuccess: null,
    activeConceptId: getActiveConceptId({redirect: false}),
    selectedIndex: getSelectedIndex(),
    totalLocationsCount: 0,
    getTotalLocationsCountSuccess: null,
    addUserAccountSuccess: null,
    addUserAccountError: null,
    getMerchantLocationsError: null,
    getMerchantLocationsSuccess: null,
    merchantLocations: {},
    getMerchantDetailsError: null,
    getMerchantDetailsSuccess: null,
    merchantDetails: {},
    updateUserAccountSuccess: null,
    updateUserAccountError: null,
    updateAccountDataSuccess: null,
    updateAccountDataError: null
};

export default function appReducer(state = initialState, action) {
    switch (action.type) {
        case SET_MODAL:
            return {
                ...state,
                modal: action.data
            };
        case SET_MODAL_RESET:
            return {
                ...state,
                modal: initialState.modal
            };
        case UPDATE_ACCOUNT_DATA:
            return {
                ...state,
                ...(action.payload && action.payload.updateAccountDataSuccess && {
                    updateAccountDataSuccess: true
                }),
                updateAccountDataError: action.error
            };
        case UPDATE_ACCOUNT_DATA_RESET:
            return {
                ...state,
                updateAccountDataSuccess: initialState.updateAccountDataSuccess,
                updateAccountDataError: initialState.updateAccountDataError
            };
        case GET_DASHBOARD:
            return {
                ...state,
                ...(action.payload && action.payload.getDashboardSuccess && {
                    getDashboardSuccess: action.payload.getDashboardSuccess,
                    activeConcept: action.payload.activeConcept,
                    merchantGroup: action.payload.merchantGroup,
                    concepts: action.payload.concepts
                }),
                getDashboardError: action.error
            };
        case GET_DASHBOARD_RESET:
            return {
                ...state,
                getDashboardSuccess: initialState.getDashboardSuccess
                // guestCheckoutRemoveCartItemSuccess: initialState.guestCheckoutRemoveCartItemSuccess,
                // guestCheckoutRemoveCartItemError: initialState.guestCheckoutRemoveCartItemError,
                // guestCheckoutRemoveCartItemCartItem: initialState.guestCheckoutRemoveCartItemCartItem
            };

        case GET_MERCHANT_DETAILS:
            return {
                ...state,
                ...(action.payload && action.payload.getMerchantDetailsSuccess && {
                    merchantDetails: action.payload.merchantDetails,
                    getMerchantDetailsSuccess: true,
                }),
                getMerchantDetailsError: action.error
            };
        case GET_MERCHANT_DETAILS_RESET:
            return {
                ...state,
                getMerchantDetailsError: initialState.getMerchantDetailsError,
                getMerchantDetailsSuccess: initialState.getMerchantDetailsSuccess,
                merchantDetails: initialState.merchantDetails
                // guestCheckoutRemoveCartItemSuccess: initialState.guestCheckoutRemoveCartItemSuccess,
                // guestCheckoutRemoveCartItemError: initialState.guestCheckoutRemoveCartItemError,
                // guestCheckoutRemoveCartItemCartItem: initialState.guestCheckoutRemoveCartItemCartItem
            };
        case GET_MERCHANT_LOCATIONS:
            return {
                ...state,
                ...(action.payload && action.payload.getMerchantLocationsSuccess && {
                    getMerchantLocationsSuccess: true,
                    merchantLocations: action.payload.merchantLocations,
                }),
                getMerchantLocationsError: action.error
            };
        case GET_MERCHANT_LOCATIONS_RESET:
            return {
                ...state,
                getMerchantLocationsError: initialState.getMerchantLocationsError,
                getMerchantLocationsSuccess: initialState.getMerchantLocationsSuccess,
                merchantLocations: initialState.merchantLocations
                // guestCheckoutRemoveCartItemSuccess: initialState.guestCheckoutRemoveCartItemSuccess,
                // guestCheckoutRemoveCartItemError: initialState.guestCheckoutRemoveCartItemError,
                // guestCheckoutRemoveCartItemCartItem: initialState.guestCheckoutRemoveCartItemCartItem
            };
        case GET_MERCHANT_REPORT:
            return {
                ...state,
                ...(action.payload && action.payload.getMerchantReportSuccess && {
                    merchantReport: action.payload.merchantReport,
                    getMerchantReportSuccess: true,
                }),
                getDashboardError: action.error
            };
        case GET_MERCHANT_REPORT_RESET:
            return {
                ...state,
                // guestCheckoutRemoveCartItemSuccess: initialState.guestCheckoutRemoveCartItemSuccess,
                // guestCheckoutRemoveCartItemError: initialState.guestCheckoutRemoveCartItemError,
                // guestCheckoutRemoveCartItemCartItem: initialState.guestCheckoutRemoveCartItemCartItem
            };
        case GET_ACCOUNT_DATA:
            return {
                ...state,
                ...(action.payload && action.payload.getAccountDataSuccess && {
                    accountData: action.payload.accountData,
                    getAccountDataSuccess: true,
                }),
                getAccountDataError: action.error
            };
        case GET_ACCOUNT_DATA_RESET:
            return {
                ...state,
                accountData: initialState.accountData,
                getAccountDataSuccess: initialState.getAccountDataSuccess,
                getAccountDataError: initialState.getAccountDataError
                // guestCheckoutRemoveCartItemSuccess: initialState.guestCheckoutRemoveCartItemSuccess,
                // guestCheckoutRemoveCartItemError: initialState.guestCheckoutRemoveCartItemError,
                // guestCheckoutRemoveCartItemCartItem: initialState.guestCheckoutRemoveCartItemCartItem
            };
        case GET_ACCOUNT_USERS:
            return {
                ...state,
                ...(action.payload && action.payload.getAccountUsersSuccess && {
                    accountUsers: action.payload.accountUsers,
                    getAccountUsersSuccess: true,
                }),
                getAccountUsersError: action.error
            };
        case GET_ACCOUNT_USERS_RESET:
            return {
                ...state,
                accountUsers: initialState.accountUsers,
                getAccountUsersSuccess: initialState.getAccountUsersSuccess
                // guestCheckoutRemoveCartItemSuccess: initialState.guestCheckoutRemoveCartItemSuccess,
                // guestCheckoutRemoveCartItemError: initialState.guestCheckoutRemoveCartItemError,
                // guestCheckoutRemoveCartItemCartItem: initialState.guestCheckoutRemoveCartItemCartItem
            };
        case ADD_USER_ACCOUNT:
            return {
                ...state,
                ...(action.payload && action.payload.addUserAccountSuccess && {
                    addUserAccountSuccess: true,
                }),
                addUserAccountError: action.error
            };
        case ADD_USER_ACCOUNT_RESET:
            return {
                ...state,
                userAccount: initialState.userAccount,
                addUserAccountSuccess: initialState.getUserAccountSuccess,
                addUserAccountError: initialState.getUserAccountError
            };
        case GET_USER_ACCOUNT:
            return {
                ...state,
                ...(action.payload && action.payload.getUserAccountSuccess && {
                    userAccount: action.payload.userAccount,
                    getUserAccountSuccess: true,
                }),
                getUserAccountError: action.error
            };
        case GET_USER_ACCOUNT_RESET:
            return {
                ...state,
                userAccount: initialState.userAccount,
                getUserAccountSuccess: initialState.getUserAccountSuccess
                // guestCheckoutRemoveCartItemSuccess: initialState.guestCheckoutRemoveCartItemSuccess,
                // guestCheckoutRemoveCartItemError: initialState.guestCheckoutRemoveCartItemError,
                // guestCheckoutRemoveCartItemCartItem: initialState.guestCheckoutRemoveCartItemCartItem
            };
        case SET_ACTIVE_CONCEPT_ID:
            setActiveConceptId(action.payload.activeConceptId);
            return {
                ...state,
                activeConceptId: action.payload.activeConceptId
            };
        case SET_SELECTED_INDEX:
            setSelectedIndex(action.payload);
            return {
                ...state,
                selectedIndex: action.payload
            };
        case GET_TOTAL_LOCATIONS_COUNT:
            return {
                ...state,
                ...(action.payload && action.payload.getTotalLocationsCountSuccess && {
                    totalLocationsCount: action.payload.totalLocationsCount,
                    getTotalLocationsCountSuccess: action.payload.getTotalLocationsCountSuccess,
                }),
                getTotalLocationsCountError: action.error
            };
        default:
            return state;
    }
}
